import { render } from "./HomePurchases.vue?vue&type=template&id=59486d96&scoped=true"
import script from "./HomePurchases.vue?vue&type=script&lang=js"
export * from "./HomePurchases.vue?vue&type=script&lang=js"

import "./HomePurchases.vue?vue&type=style&index=0&id=59486d96&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59486d96"]])

export default __exports__